import * as React from 'react';
import { useState, useEffect, useCallback }  from 'react';
import { app } from '../config/app.js';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
import {  getPermission } from '../controller/user.js';
import {  getDataByKey } from '../controller/firestore.js';
import { updateDocToDb } from '../controller/firestore.js';

import {  CustomTabPanel, a11yProps } from '../components/CustomTabPanel.js';
import Button from '@mui/material/Button';
import dayjs from 'dayjs';
import { DateTimeField } from '@mui/x-date-pickers/DateTimeField';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { DateField } from '@mui/x-date-pickers';
import {  Navigate , Link } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { useLocation } from 'react-router-dom';

import Stack from '@mui/material/Stack';
export default function ViewSingleRecord(props) {
  const user=props.user;
  const location=useLocation();
  const httpdata = location.state && location.state.data;
  const collectionName=props.collectionName;  
  const inputDoc=(httpdata.docData?httpdata.docData:null);
  
  const id=(httpdata.id?httpdata.id:null);
  //console.log("ViewSingleRecord",httpdata);
  const callerUrl=httpdata.callerUrl;
  const activePermission=getPermission("collection",collectionName,null,user);
  
  const title="Visualizza "+app.collections_config[collectionName].singleLabel;
  const [viewConfig,setViewConfig]=useState(app.collections_config[collectionName].views.view);
  const [formClosed,setFormClosed] =useState(false);
  const [errorMessage,setErrorMessage] =useState("");
  const addingTabs=viewConfig.addingTabs!=null ? viewConfig.addingTabs : null;
  const [innerChanged,setInnerChanged]=useState(null);
  let isLoadingTable={};
  useEffect(() => {
    
    const fetchData = async () => {
      const params = {
        "where":["id", "==", id],
        "pagination":false
      }
      if (viewConfig.debug)
        console.log("Fetch data id",id);
      //if (inputDoc==null) 
      //else console.log("Salto fetch data id perchè ho già documento",inputDoc.data);
      //const doc=(inputDoc!=null?inputDoc.data:await getDataByKey(collectionName,id));
      console.log("Get data by key "+collectionName,id);
      const doc=await getDataByKey(collectionName,id);
      const valueElements=getValueElementsFromDoc(doc);
      setValues(valueElements);
      
    };
    
    if (isLoadingTable[id]) return;
    isLoadingTable[id]=true;
    if (id) fetchData();
  }, []);
  function getValueElementsFromDoc(doc) {
    
    let valueElements={};
    for (let i=0;i<viewConfig.fieldList.length;i++) {
      const gridElement=viewConfig.fieldList[i];
      if (gridElement.field==="id")
        valueElements[gridElement.field]=id;  
      else
        valueElements[gridElement.field]=(doc?doc[gridElement.field]:null);
      if (gridElement.type==="datetime") {
        if (gridElement.debug)
          console.log("Got datetime ",valueElements[gridElement.field]);
        if (valueElements[gridElement.field]===undefined || typeof(valueElements[gridElement.field].toDate)!=="function")
          valueElements[gridElement.field]=null;
        else
          valueElements[gridElement.field]=valueElements[gridElement.field].toDate();
      }
      if (gridElement.type==="date") {
        if (gridElement.debug)
          console.log("Got date ",valueElements[gridElement.field]);
        if (valueElements[gridElement.field]===undefined || typeof(valueElements[gridElement.field].toDate)!=="function")
          valueElements[gridElement.field]=null;
        else
          valueElements[gridElement.field]=valueElements[gridElement.field].toDate();
      }
      if (!valueElements[gridElement.field]) valueElements[gridElement.field]="";
    }
    if (valueElements.id===undefined) valueElements.id=id;
    valueElements.doc=doc;
    return valueElements;
  }
  useEffect(() => {
    const doc=innerChanged;
    if (doc!=null) {
      const valueElements=getValueElementsFromDoc(doc);
      setValues(valueElements);
    }
  }, [innerChanged]);
  let valueElements={};
  for (let i=0;i<viewConfig.fieldList.length;i++) {
    const gridElement=viewConfig.fieldList[i];
    let value=null;
    if (gridElement.debug===true) console.log("Init Step 0 "+gridElement.field+" value:",value);
    if (value===null && gridElement.default!==undefined && gridElement.default!==null) 
      value=gridElement.default;
      if (gridElement.debug===true) console.log("Init Step 1 "+gridElement.field+" value:",value);
    if (value===null && gridElement.default_function!==undefined) {
      const asyncRequired=app.services[gridElement.default_function].async;     
      
      if (!asyncRequired) value=app.services[gridElement.default_function].func(gridElement,value);
    }
    if (gridElement.debug===true) console.log("Init Step 2 "+gridElement.field+" value:",value);
    if (value===null||value===undefined) value="";
    if (gridElement.debug===true) console.log("Init Step 3 "+gridElement.field+" value:",value);
    valueElements[gridElement.field]=value;

  }
  
  const handleChangeTabState = (event, newValue) => {
    //const tabMap=["data","filter"];
    setTabState(newValue);
    return;
    const tabMap=[0,1];
    setTabState(tabMap[newValue]);
  };
  const [tabState, setTabState] = React.useState(0);
  const addLink="/"+collectionName+"/update";
  const currentPath="/"+collectionName;
  const [values, setValues]=useState(valueElements);
  return (
    <React.Fragment>
      {
      formClosed &&
      <Navigate to={callerUrl} />  
      }
      <Typography sx={{pb:2}} variant="h6" gutterBottom>
        {title}
      </Typography>
      <Box sx={{ width: '100%' }}>
        
        
        {addingTabs!=null && <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={tabState} onChange={handleChangeTabState} aria-label="basic tabs example">
              <Tab key={0} label="Dati" {...a11yProps(0)} />
              {addingTabs.map(tab => (  
                <Tab key={tab.key} label={tab.label} {...a11yProps(addingTabs.indexOf(tab)+1)} />
              ))}
              
              
            </Tabs>
          </Box>
        }
          <CustomTabPanel  value={tabState} index={0}>
            <Grid container sx={{ pt:2}} spacing={3}>
              {values && viewConfig.fieldList.map( gridElement => (
                gridElement.showOnNew!==false ?(<Grid item key={gridElement.field} {...gridElement.gridProp}>

                  <RenderItem key={gridElement.field} item={gridElement} value={values[gridElement.field]} />
            </Grid>) : null
            ))}
            </Grid>   
            <Stack sx={{mt:2}} align="right" direction="row" spacing={2}>
              <Button  component={Link} to={callerUrl} variant="contained">Chiudi</Button>
              <Button  component={Link} to={ addLink }  state= {{ data: {callerUrl:currentPath, id:id }}} >Modifica</Button>
            </Stack>   
          </CustomTabPanel>
          {addingTabs!=null && addingTabs.map(tab => (
            <CustomTabPanel key={tab.key} value={tabState} index={addingTabs.indexOf(tab)+1}>
              <tab.Component  {...tab.props} user={user} collectionName={collectionName} docData={values.doc} id={id} setDocChanged={setInnerChanged} />
            </CustomTabPanel>
          ))}
        </Box>      
      
      
    </React.Fragment>
  );
}
function RenderItem({item,value}) {
  const [asyncOptionData, setAsyncOptionData] = useState(null);
  const editable=false;
  let asyncRequired=false;
  
  const labelId=item.field+"-label";
  useEffect(() => {
    async function fetchData() {
      try {
        const obtainedData=await app.services[item.option_service]["func"](item,value);
        setAsyncOptionData(obtainedData);
        
      } catch (error) {
        console.error('Errore nella chiamata asincrona', error);
        
      }
    }
    if (asyncRequired && asyncOptionData===null)
      fetchData(); // Esegui la chiamata asincrona solo una volta all'avvio del componente
  }, []); 
  
  if (item.debug) console.log("Value input "+item.field,value);
  if (item.hidden) {
    return <input type='hidden' {...item.textProp}  value={value} required={item.required} id={item.field} name={item.field} label={item.headerName} />;
  }
  let renderType=item.type;
  //if (!editable) {
  //  renderType="text";
 // }
  
    switch (renderType) {
      case 'select':
        let options=item.options;
        
        if (item.option_service) { 
          
          asyncRequired=app.services[item.option_service].async;
          if (!asyncRequired) options=app.services[item.option_service].func(item,value);
        }
        
        return ( 
        <FormControl fullWidth>
        <InputLabel id={labelId}>{item.headerName}{item.required ? '*':''}</InputLabel>
        <Select fullWidth {...item.textProp} editable={editable.toString()} variant="standard" inputprops={{
            readOnly: true,
          }} required={item.required} labelId={labelId} id={item.field} name={item.field} label={item.headerName} value={value}>
          {
            asyncRequired ? 
              (
                (
                  asyncOptionData ===null ? 
                  (
                    <div>Loading</div>
                  )  :
                  (
                
                    asyncOptionData.map(option => (
                      <MenuItem key={option.value} value={option.value} selected={option.value === value}>{option.label}</MenuItem>               
                    ))

                  )
                )
              ) : (
                (
                  options ===null ? 
                  (
                    
                    <div>Loading synced</div>
                  ):
                  (
                    options.map(option => (
                      <MenuItem key={option.value} value={option.value} selected={option.value === value}>{option.label}</MenuItem>               
                    ))
                  )
                )
              )
          }
          </Select></FormControl>);
      case 'boolean':
        return <FormControl fullWidth><TextField  fullWidth {...item.textProp} variant="standard" required={item.required} id={item.field} name={item.field} label={item.headerName}/></FormControl>;
      case 'date':
        return  <FormControl fullWidth><DateField   variant="standard" label={item.headerName} {...item.textProp} required={item.required} id={item.field} InputProps={{
          readOnly: true,
        }} name={item.field} value={(value!=""?dayjs(value):null)} /></FormControl>;
      case 'datetime':
        return  <FormControl fullWidth><DateTimeField   variant="standard" label={item.headerName} {...item.textProp} InputProps={{
          readOnly: true,
        }} required={item.required} id={item.field} name={item.field} value={(value!=""?dayjs(value):null)}  /></FormControl>;
      
      default:
        return <TextField fullWidth {...item.textProp} variant="standard" value={value} required={item.required} id={item.field} name={item.field} label={item.headerName} InputProps={{
          readOnly: !editable,
        }} />;
    }
  
}